import React from 'react'
import { CircularProgress } from '@material-ui/core'
// @src imports
import { DefaultError } from 'src/chrome'
import { useSelector } from 'src/hooks'
import Images from './Images'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import { Api, ToasterNotification } from '../api'

import UploadFooter from './UploadFooter'
import { IsMemoizedFuction } from 'src/hooks/dependencies'
import { useDeleteImage, useInfiniteImages } from 'src/react_query'
import { ImageFragment } from 'src/graphql/generated/graphql'

type Props = {
  api: Api
  onSelect?: ((image: ImageFragment) => void) & IsMemoizedFuction
}

const SOCImages: React.FC<Props> = props => {
  const isMobile = useSelector(state => state.window.isMobile)

  const {
    api: { isImageSettingExpanded, setToasterNotification },
    onSelect,
  } = props
  const deleteImage = useDeleteImage()
  const imagesQuery = useInfiniteImages()
  const images = imagesQuery.data?.pages.flat() ?? []

  const imageDeletedToasterNotification: ToasterNotification = {
    iconName: 'squareCheck',
    content: 'Image deleted successfully',
    type: 'success',
  }

  const handleDeleteImage = (id: string) => {
    try {
      deleteImage.mutate({ id })
    } catch (err) {
      console.log(err)
    } finally {
      if (isMobile) setToasterNotification(imageDeletedToasterNotification)
    }
  }

  return (
    <>
      <Images
        result={images.map(image => ({
          ...image,
          smallThumb: image.smallThumb ? image.smallThumb : image.url,
        }))}
        isLoading={imagesQuery.isLoading}
        hasMore={imagesQuery.hasNextPage ?? false}
        loadMore={imagesQuery.fetchNextPage}
        onSelect={onSelect}
        deleteImage={handleDeleteImage}
        isExpanded={isImageSettingExpanded}
        isMobile={isMobile}
      />
      {!isMobile && <UploadFooter api={props.api} onSelect={onSelect} />}
    </>
  )
}
export default suspenseBoundary({
  component: SOCImages,
  unresolved: (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <CircularProgress />
    </div>
  ),
  failure: DefaultError,
})
